
export default function authUploadFile () {
  return { accept: '*/*', 'Content-Type': 'multipart/form-data' }
}
